(function () {
  var TARGET = "a, button, input, select, textarea, label, summary, [role='button']";
  var CHECKOUT = ".rebuy-cart__checkout-button, [name='checkout'], a[href$='/checkout'], .shopify-payment-button";
  var pending = [];
  var touched = new Map();
  var clicks = [];
  var atcTracked = false;
  var atcState = "";
  var observers = [];
  var checkoutAt = -Infinity;

  function analyticsDenied() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.analyticsProcessingAllowed !== "function") return false;
    try {
      return !privacy.analyticsProcessingAllowed();
    } catch (_) {
      return true;
    }
  }

  function emit(event, key, value) {
    if (typeof window.clarity !== "function") return false;
    try {
      window.clarity("set", key, value);
      window.clarity("event", event);
    } catch (_) {}
    return true;
  }

  function drain() {
    if (analyticsDenied()) {
      pending.length = 0;
      return;
    }
    while (pending.length && emit.apply(null, pending[0])) pending.shift();
  }

  function send(event, key, value) {
    drain();
    if (analyticsDenied()) return;
    if (!emit(event, key, value) && pending.length < 20) pending.push([event, key, value]);
  }

  function describe(el) {
    el = (el.closest && el.closest(TARGET)) || el;
    var tag = el.tagName.toLowerCase();
    if (el.id && !/\d{4,}/.test(el.id)) return tag + "#" + el.id;
    var cls = typeof el.className === "string" ? el.className.trim().split(/\s+/).slice(0, 2).join(".") : "";
    return cls ? tag + "." + cls : tag;
  }

  function formName(form) {
    var type = form.querySelector("input[name='form_type']");
    return (type && type.value) || form.getAttribute("action") || "form";
  }

  function onClick(e) {
    var t = e.timeStamp;
    var checkout = e.target.closest && e.target.closest(CHECKOUT);
    if (checkout && !e.target.closest(".shopify-payment-button__more-options") && t - checkoutAt >= 2000) {
      checkoutAt = t;
      touched.clear();
      send(
        "au_checkout_click",
        "au_checkout_from",
        checkout.closest(".shopify-payment-button") ? "buy-now" : checkout.closest("#rebuy-cart") ? "drawer" : "page"
      );
    }
    if (!e.detail || (clicks.length && clicks[clicks.length - 1].t === t)) return;
    clicks = clicks.filter(function (c) {
      return t - c.t < 700 && Math.abs(c.x - e.clientX) < 30 && Math.abs(c.y - e.clientY) < 30;
    });
    clicks.push({ t: t, x: e.clientX, y: e.clientY, el: e.target });
    if (clicks.length < 3) return;
    send("au_rage_click", "au_rage_target", describe(clicks[0].el));
    clicks = [];
  }

  function onInput(e) {
    var field = e.target;
    var form = field.form;
    if (!form || !field.name || !/^(text|email|tel|password|textarea)$/.test(field.type)) return;
    if (/\/search$/.test(form.getAttribute("action") || "")) return;
    touched.set(form, field.name);
  }

  function atcSeen(where) {
    if (atcState) return;
    var s = performance.now() / 1000;
    atcState = where + " " + (s < 3 ? "0-3s" : s < 10 ? "3-10s" : s < 30 ? "10-30s" : "30s+");
    observers.forEach(function (o) {
      o.disconnect();
    });
    send("au_atc_seen", "au_atc_seen", atcState);
  }

  function watchAtc() {
    var type = document.querySelector("meta[name='au:page-type']");
    if (!type || type.content !== "product" || !("IntersectionObserver" in window)) return;
    var main = Array.prototype.find.call(
      document.querySelectorAll(".main-product--root .product-buy-buttons--primary"),
      function (el) {
        return !el.closest(".product-buy-buttons--drawer");
      }
    );
    var sticky = document.querySelector(".main-product--root .product-buy-buttons--drawer");
    if (!main) return;
    atcTracked = true;
    var io = new IntersectionObserver(
      function (entries) {
        if (entries.some(function (en) { return en.isIntersecting; })) atcSeen("main");
      },
      { threshold: 0.5 }
    );
    io.observe(main);
    observers.push(io);
    if (!sticky) return;
    var mo = new MutationObserver(function () {
      if (sticky.getAttribute("aria-hidden") === "false" && sticky.getClientRects().length) atcSeen("sticky");
    });
    mo.observe(sticky, { attributes: true, attributeFilter: ["aria-hidden"] });
    observers.push(mo);
  }

  function onPageHide() {
    touched.forEach(function (field, form) {
      send("au_form_abandon", "au_form_abandon", formName(form) + ":" + field);
    });
    touched.clear();
    if (atcTracked && !atcState) {
      atcState = "never";
      send("au_atc_seen", "au_atc_seen", "never");
    }
    drain();
  }

  document.addEventListener("click", onClick, { capture: true, passive: true });
  document.addEventListener("input", onInput, true);
  document.addEventListener(
    "submit",
    function (e) {
      touched.delete(e.target);
    },
    true
  );
  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "hidden") drain();
  });
  document.addEventListener("visitorConsentCollected", drain);
  window.addEventListener("pagehide", onPageHide);

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", watchAtc, { once: true });
  else watchAtc();
})();
